import { BaseModel } from '@shared/base/Base.Model';
import { IRestModel } from '@shared/interface/IRestModel';
import { RestModelUtility } from '@shared/utility/RestModel.Utility';
import { ISyncedVideoSessionModel, SyncedVideoSessionModel } from './SyncedVideoSession.Model';

export interface ISyncedVideoSessionNodeModel extends IRestModel {
    serial: string;
    syncedVideoSessionData: ISyncedVideoSessionModel;
}

export class SyncedVideoSessionNodeModel extends BaseModel implements ISyncedVideoSessionNodeModel, IRestModel {
    public readonly isIRestModel = true;

    public error: string = null;
    public statusCode: number = null;

    public serial: string = null;
    public syncedVideoSessionData: ISyncedVideoSessionModel = null;

    public constructor() {
        super();
    }

    public loadFromRestApiModel(restModel: any): void {
        RestModelUtility.loadProperties(restModel, this, 'RIFT-SyncedVideoSessionNodeModel');

        this.syncedVideoSessionData = RestModelUtility.loadFrom(restModel.SyncedVideoSessionData, SyncedVideoSessionModel);
    }

    public toRestApiModel(): any {
        return {
            ...RestModelUtility.toJson(this)
        };
    }
}
